import React from "react";
import { Box } from "@chakra-ui/react";
import { DatePickerButtonProps } from "./DatePickerButton.types";

const DatePickerButton: React.FC<DatePickerButtonProps> = ({
  children,
  isPartialSelected,
  isSelected,
  isDisabled,
  isGrey,
  isInRange,
  isStartRange,
  isEndRange,
  ...rest
}) => {
  let color = "grey.700";
  let bg = "transparent";

  if (isSelected) {
    color = isDisabled ? "brand.main" : "white";
  } else if (!isGrey && !isDisabled) {
    color = "ink";
  }

  if (isDisabled) {
    bg = "bg.grey";
  } else if (isSelected) {
    bg = isInRange && !isStartRange && !isEndRange ? "light.300" : "brand.main";
  }

  return (
    <Box
      px={3}
      my={1}
      py={1}
      w={"100%"}
      textAlign={"center"}
      textStyle={"bodyRegular"}
      color={color}
      bg={bg}
      border={"1px solid"}
      borderColor={isPartialSelected ? "brand.main" : "transparent"}
      borderRadius={isInRange ? 0 : 4}
      borderTopLeftRadius={!isInRange || isStartRange ? 4 : 0}
      borderBottomLeftRadius={!isInRange || isStartRange ? 4 : 0}
      borderTopRightRadius={!isInRange || isEndRange ? 4 : 0}
      borderBottomRightRadius={!isInRange || isEndRange ? 4 : 0}
      _hover={
        isDisabled
          ? {
              cursor: "not-allowed",
            }
          : {
              bg: isSelected ? "brand.main" : "grey.900",
              color: isSelected ? "white" : "ink",
              cursor: "pointer",
            }
      }
      {...rest}
    >
      {children}
    </Box>
  );
};

export default DatePickerButton;
